import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpRequest } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GiveawayStockService {


  constructor(private readonly http: HttpClient,
    private readonly configurations: ConfigurationService) { }

  getAll() {
    return this.http.get(`${this.configurations.apiAddress}/api/GiveawayStock/getAll`);
  }

  getById(id) {
    return this.http.get(`${this.configurations.apiAddress}/api/GiveawayStock/getById/${id}`);
  }

  delete(id) {
    return this.http.delete(`${this.configurations.apiAddress}/api/GiveawayStock/delete/${id}`);
  }

  save(item) {
    return this.http.post(`${this.configurations.apiAddress}/api/GiveawayStock/save`, item);
  }

}
